import { render, staticRenderFns } from "./orderedit_formbns.vue?vue&type=template&id=216d6a01&scoped=true&"
import script from "./orderedit_formbns.vue?vue&type=script&lang=js&"
export * from "./orderedit_formbns.vue?vue&type=script&lang=js&"
import style0 from "./orderedit_formbns.vue?vue&type=style&index=0&id=216d6a01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d6a01",
  null
  
)

export default component.exports